(() => {
  const initComparison = (comparison) => {
    if (comparison.dataset.comparisonInitialized === 'true') return;

    const source = comparison.querySelector('[data-comparison-source]');
    const canvas = comparison.querySelector('[data-comparison-canvas]');
    const range = comparison.querySelector('.vectorization-comparison__range');

    if (!source || !canvas || !range) return;

    comparison.dataset.comparisonInitialized = 'true';

    const pixelSize = Math.max(
      2,
      Number.parseInt(comparison.dataset.pixelSize || '4', 10)
    );

    const ctx = canvas.getContext('2d', { alpha: false });

    const drawPixelated = () => {
      const stageRect = comparison.getBoundingClientRect();

      if (!stageRect.width || !stageRect.height || !source.naturalWidth) return;

      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const outputWidth = Math.max(1, Math.round(stageRect.width * dpr));
      const outputHeight = Math.max(1, Math.round(stageRect.height * dpr));

      canvas.width = outputWidth;
      canvas.height = outputHeight;

      const scale = Math.max(
        outputWidth / source.naturalWidth,
        outputHeight / source.naturalHeight
      );

      const renderedWidth = source.naturalWidth * scale;
      const renderedHeight = source.naturalHeight * scale;
      const offsetX = (outputWidth - renderedWidth) / 2;
      const offsetY = (outputHeight - renderedHeight) / 2;

      const lowWidth = Math.max(1, Math.round(outputWidth / pixelSize));
      const lowHeight = Math.max(1, Math.round(outputHeight / pixelSize));

      const temp = document.createElement('canvas');
      temp.width = lowWidth;
      temp.height = lowHeight;

      const tempCtx = temp.getContext('2d', { alpha: false });

      tempCtx.imageSmoothingEnabled = true;
      tempCtx.drawImage(
        source,
        offsetX / pixelSize,
        offsetY / pixelSize,
        renderedWidth / pixelSize,
        renderedHeight / pixelSize
      );

      ctx.clearRect(0, 0, outputWidth, outputHeight);
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(temp, 0, 0, lowWidth, lowHeight, 0, 0, outputWidth, outputHeight);
    };

    const updatePosition = () => {
      comparison.style.setProperty('--comparison-position', `${range.value}%`);
    };

    source.addEventListener('load', drawPixelated);
    range.addEventListener('input', updatePosition);
    range.addEventListener('change', updatePosition);

    const resizeObserver = new ResizeObserver(() => {
      window.requestAnimationFrame(drawPixelated);
    });

    resizeObserver.observe(comparison);

    if (source.complete) {
      drawPixelated();
    }

    updatePosition();
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-vector-comparison]').forEach(initComparison);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
